import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CarrierKeyNameItem, CarrierService } from '@app/services/carrier.service';
import { LogisticService, PlanPolicyItem, PohCompletionPrincipleItem } from '@app/services/logistic.service';
import { ProductGet } from '@app/services/product.service';
import { forkJoin, from, ReplaySubject, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'tt-product-stock-form',
    templateUrl: './product-stock-form.component.html',
    styleUrls: ['./product-stock-form.component.css'],
})
export class ProductStockFormComponent implements OnInit, OnDestroy, OnChanges {
    @Input()
    public set params(value: ProductGet | undefined) {
        this.setParams(value);
    }
    public get params() {
        return this._params;
    }
    private _params?: ProductGet;

    @Output()
    public paramsChange = new EventEmitter<ProductGet>();

    private setParams(value: ProductGet | undefined) {
        this._params = value;

        if (!!value) {
            this.params$.next(value);
        }
    }

    private destroy$ = new Subject<void>();

    private params$ = new ReplaySubject<ProductGet>(1);

    public planPolicies: PlanPolicyItem[] = [];

    public completionPrinciples: PohCompletionPrincipleItem[] = [];

    public carriers: CarrierKeyNameItem[] = [];

    constructor(
        private logistic: LogisticService,
        private carrier: CarrierService,
        private cdr: ChangeDetectorRef,
    ) {}

    public onChanged(key: keyof ProductGet) {
        if (!this.params) return;

        this.paramsChange.emit(this.params);
    }

    private loadStaticData() {
        forkJoin({
            planPolicies: from(this.logistic.getPlanPolicies()),
            completionPrinciples: from(this.logistic.getPohCompletionPrinciples()),
            carriers: from(this.carrier.getCarriersKeyNames()),
        })
            .pipe(takeUntil(this.destroy$))
            .subscribe((result) => {
                this.planPolicies = result.planPolicies;
                this.completionPrinciples = result.completionPrinciples;
                this.carriers = result.carriers;
                this.cdr.markForCheck();
            });
    }

    ngOnInit(): void {
        this.loadStaticData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.setParams(changes['params'].currentValue);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
